// Cuándo se generó una foto, como lo diría uno — ADR-2026-09-16-la-card-de-info-del-lienzo.
//
// Cerca, "hace cuánto" (`cuando`, el de los comentarios: "ahora", "hace 2 min",
// "hace 3 h"); pasado el día ya importa CUÁNDO fue, y ahí manda `fechaSmart`
// ("Ayer 10:22 hs", "Lunes 14:05 hs", "3 sep 10:22 hs"). `ahora` se inyecta para poder
// probarlo con un reloj fijo.

import { fechaSmart } from '../../utils/fechaSmart';

const MINUTO = 60_000;
const HORA = 60 * MINUTO;

export function fechaDeInfo(iso: string | null | undefined, ahora: number = Date.now()): string {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const hace = ahora - t;
  if (hace < MINUTO) return 'ahora';
  if (hace < HORA) return `hace ${Math.floor(hace / MINUTO)} min`;
  if (hace < 24 * HORA) return `hace ${Math.floor(hace / HORA)} h`;
  return fechaSmart(iso);
}
